import { render } from "./FolderTreeItem.vue?vue&type=template&id=6379d4f8&scoped=true"
import script from "./FolderTreeItem.vue?vue&type=script&lang=js"
export * from "./FolderTreeItem.vue?vue&type=script&lang=js"

import "./FolderTreeItem.vue?vue&type=style&index=0&id=6379d4f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6379d4f8"]])

export default __exports__